import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import { obtenerDiferenciaYear, calcularMarca, obtenerPlan } from "../helper";

const Campo = styled.div`
    display: flex;
    margin-bottom: 1rem;
    align-items: center;
`;

const Label = styled.label`
    flex: 0 0 100px;
`;

const Select = styled.select`
    display: block;
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #e1e1e1;
    -webkit-appearance: none;
`;

const InputRadio = styled.input`
    margin: 0 1rem;
`;

const Boton = styled.button`
    background-color: #00838F;
    font-size: 16px;
    width: 100%;
    padding: 1rem;
    color: #FFFFFF;
    text-transform: uppercase;
    font-weight: bold;
    border: none;
    border-radius: .5rem;
    margin-top: 1.5rem;
    transition: all .2s ease-in-out;

    &:hover {
        background-color: #26c6da;
        cursor: pointer;
    }
`;

const Error = styled.div`
    background-color: red;
    color: white;
    padding: 1rem;
    width: 100%;
    text-align: center;
    margin-bottom: 1rem;
    border-radius: .5rem;
`;

const Formulario = ({setResumen, setCargando}) => {

    const [datos, setDatos] = useState({
        marca: '',
        year: '',
        plan: ''
    });

    const [error, setError] = useState(false);

    //Extraer Valores
    const { marca, year, plan } = datos;

    //Leer el formulario y extraer datos
    const obtenerInformacion = e => {
        setDatos ({
            ...datos,
            [e.target.name] : e.target.value
        })
    }

    //cuando se presiona el boton
    const cotizarSeguro = e => {
        e.preventDefault();

        if (marca.trim() === '' || year.trim() === '' || plan.trim() === '') {
            setError(true);
            return;
        }
        
        setError(false); 

        //base de 2000
        let resultado = 2000;

        //obtener diferencia de años
        const diferencia = obtenerDiferenciaYear(year);        

        //por cada año -3%
        resultado -= ((diferencia * 0.03) * resultado);

        //Americano 15%
        //Asiatico 5%
        //Europeo 30%
        resultado *= calcularMarca(marca);

        //Básico +20%
        //Completo +50%
        const incrementoPlan = obtenerPlan(plan);
        resultado = parseFloat(incrementoPlan * resultado).toFixed(2);

        //Spinner > Total
        setCargando(true);

        setTimeout(() => {
            //Eliminar Spinner
            setCargando(false);
            
            //Total
            setResumen({
                cotizacion : Number(resultado),
                datos
            })

        }, 1500);

    }

    return (
			<form
                onSubmit={cotizarSeguro}
            >
                {error ? <Error>Todos los campos son Obligatorios</Error> : null}

				<Campo>
					<Label>Marca</Label>
					<Select
                        name="marca"
                        value={marca}
                        onChange={obtenerInformacion}
                        >
						<option value="">-- Seleccione --</option>
						<option value="americano">Americano</option>
						<option value="europeo">Europeo</option>
						<option value="asiatico">Asiatico</option>
					</Select>
				</Campo>
				<Campo>
					<Label>Año</Label>
					<Select
                        name="year"
                        value={year}
                        onChange={obtenerInformacion}
                        >
						<option value="">-- Seleccione --</option>
						<option value="2021">2021</option>
						<option value="2020">2020</option>
						<option value="2019">2019</option>
						<option value="2018">2018</option>
						<option value="2017">2017</option>
						<option value="2016">2016</option>
						<option value="2015">2015</option>
						<option value="2014">2014</option>
						<option value="2013">2013</option>
						<option value="2012">2012</option>
					</Select>
				</Campo>
                <Campo>
                    <Label>Plan</Label>
                    <InputRadio 
                        type="radio" 
                        name="plan" 
                        value="basico"
                        checked={plan === "basico"}
                        onChange={obtenerInformacion}
                        /> Básico
                    <InputRadio 
                        type="radio" 
                        name="plan" 
                        value="completo"
                        checked={plan === "completo"}
                        onChange={obtenerInformacion}
                    /> Completo
                </Campo>

                <Boton type="submit">Cotizar</Boton>
			</form>
		);
}

Formulario.propTypes = {
    setResumen: PropTypes.func.isRequired,
    setCargando: PropTypes.func.isRequired
}

export default Formulario;